import { defineStore } from "pinia";

export const useConfigStore = defineStore("config", {
  state: () => ({
    title: "",
    logos: [],
    links: [],
    externalSystems: [],
    dmstoken: "",
    dmss: [],
    multiRegion: true,
  }),
  actions: {
    setConfig(config: any) {
      this.title = config.title;
      this.logos = config.logos;
      this.links = config.links || [];
      this.externalSystems = config.externalSystems;
      this.dmstoken = config.DMSTOKEN;
      this.dmss = config.DMS_LIST;
      this.multiRegion = config.multiRegion ?? config.isMultiRegion ?? true;
    },
  },
  getters: {
    getLinks: (state) => state.links,
    getExternalSystems: (state) => state.externalSystems,
    getDmstoken: (state) => state.dmstoken,
    getDmss: (state) => state.dmss,
    getMultiRegion: (state) => state.multiRegion,
  },
});
